<div class="comments">
    <div class="comments-header">
        <h4>Comments</h4>
        <img class="close" (click)="close()" src="assets/images/comments/close.svg" alt="close"
            (keydown.enter)="close()" (keydown.space)="close()">
    </div>
    <div class="comments-body" #scrollDiv>
        <ng-container>
            <div class="view-more" *ngIf="comments.length >=10">
                <span (click)="loadMore()" (keydown.enter)="loadMore()" (keydown.space)="loadMore()">View More</span>
            </div>
            <div class="comment-loader" *ngIf="isLoading">Loading...</div>
            <div class="comment-loader">{{message}}</div>
            <app-comment-shared *ngFor="let comment of comments"
                [isShowReply]="(comments[comments.length - 1] === comment) ? true : false"
                [factorySummary]="factorySummary" [dasboardName]="dashboardName" [comment]="comment"
                (scrollBottom)="scrollToBottom()">
            </app-comment-shared>
        </ng-container>
    </div>
    <div class="comment-box-container">

        <div class="comment-box">
            <div class="letter-avatar">
                <div class="name">
                    <span>{{shortName}}</span>
                </div>
            </div>
            <div class="comment-box-input">
                <quill-editor [(ngModel)]="htmlText" placeholder="Write a comment" [modules]="quillConfig2"
                    [styles]="{height: '60px'}" (onContentChanged)="onContentChanged($event)">
                </quill-editor>
            </div>
        </div>
        <div class="comment-box-footer">
            <div class="cb-loader" *ngIf="isSending">Sending...</div>
            <button class="cb-btn-send" (click)="postComment()" [disabled]="!htmlText || isSending">
                <img src="assets/images/comments/send.svg" alt="send">
            </button>
        </div>

    </div>
</div>